import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setWalletTemplateForGroup = ({ benefitId, benefitType }) =>
  call(websocketFetch, 'set_wallet_template_for_group', {
    benefit_id: benefitId,
    benefit_type: benefitType,
  });
